import { render, staticRenderFns } from "./addMeterWater.vue?vue&type=template&id=fb2d6550&scoped=true"
import script from "./addMeterWater.vue?vue&type=script&lang=js"
export * from "./addMeterWater.vue?vue&type=script&lang=js"
import style0 from "./addMeterWater.vue?vue&type=style&index=0&id=fb2d6550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2d6550",
  null
  
)

export default component.exports